(() => {
  const SELECTOR = '[data-rg-carousel]';

  function syncVideos(carousel) {
    carousel.querySelectorAll('video').forEach((video) => {
      const slide = video.closest('.swiper-slide');
      const isActive = slide && slide.classList.contains('swiper-slide-active');

      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;

      if (isActive) {
        video.preload = 'auto';
        playVideo(video);
      } else {
        video.pause();
        if (video.readyState === 0) video.preload = 'none';
      }
    });
  }

  function playVideo(video) {
    const attemptPlay = () => {
      const slide = video.closest('.swiper-slide');
      if (!slide || !slide.classList.contains('swiper-slide-active')) return;

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    if (video.readyState >= 2) {
      attemptPlay();
      return;
    }

    video.addEventListener('canplay', attemptPlay, { once: true });
    video.load();
  }

  function initCarousel(carousel) {
    if (carousel.dataset.rgCarouselReady === 'true' || typeof window.Swiper !== 'function') return;

    carousel.dataset.rgCarouselReady = 'true';

    const swiper = new window.Swiper(carousel, {
      autoplay: false,
      breakpoints: {
        750: {
          spaceBetween: 33,
        },
      },
      centeredSlides: true,
      grabCursor: true,
      initialSlide: 0,
      keyboard: {
        enabled: true,
      },
      loop: true,
      loopAdditionalSlides: 0,
      loopPreventsSliding: false,
      navigation: {
        nextEl: carousel.querySelector('.rg__carousel-arrow--next'),
        prevEl: carousel.querySelector('.rg__carousel-arrow--prev'),
      },
      pagination: {
        clickable: true,
        el: carousel.querySelector('.rg__carousel-pagination'),
      },
      slidesPerView: 'auto',
      spaceBetween: 14,
      speed: 500,
      watchOverflow: false,
      on: {
        init() {
          syncVideos(carousel);
        },
        slideChange() {
          syncVideos(carousel);
        },
        slideChangeTransitionEnd() {
          syncVideos(carousel);
        },
      },
    });

    carousel.rgSwiper = swiper;
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initCarousel);
  }

  function start() {
    if (typeof window.Swiper === 'function') {
      initAll();
      return;
    }

    window.setTimeout(start, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
